<template>
    <b-container fluid class="h-100">
        <b-row class="h-100 bg-1 justify-content-center align-items-center">
            <transition name="fade" mode="out-in">
                <router-view/>
            </transition>
        </b-row>
    </b-container>
</template>

<script>
    export default {
        name: "AuthLayout"
    }
</script>

<style scoped>

</style>
